import React from "react";
import { Timeline, Tag } from "antd";

const getTagColor = (estado) => {
  switch (estado) {
    case "devolucion":
      return "orange";
    case "solicitud_prestamo":
      return "green";
    default:
      return "blue";
  }
};

const PrestamoTimeline = ({ historialData }) => (

  <Timeline>
    {historialData.map((item) => (
      <Timeline.Item key={item.id}>
        <p>Préstamo ID: {item?.prestamo_ns_p?.id || "N/A"}</p>
        <p>Cantidad: {item?.cantidad}</p>
        <p>
          Vendedor: <Tag color={getTagColor(item?.estado)}>{item?.vendedor?.first_name || item?.vendedor || 'N/A'}</Tag>
        </p>
        {item?.precio_producto && (
          <p>Precio producto: ${item?.precio_producto}</p>
        )}
        <p>
          Estado: <Tag color={getTagColor(item?.estado)}>{item?.estado}</Tag>
        </p>
        <p>Fecha: {new Date(item?.fecha).toLocaleDateString()}</p>
      </Timeline.Item>
    ))}
  </Timeline>
);

export default PrestamoTimeline; 